import { call, put, takeEvery } from 'redux-saga/effects'
import selectIdToken from '../selectors/select-id-token'
import fileDownload from 'js-file-download'
import { DownloadActiveMetersAction } from './reports-actions'
import { selectFromState } from '../selectors/select-from-state'
import { AdminReportsApi } from '../../api/admin-reports-api'
import { type DownloadFileResponse } from '../../api/types'
import { AddMessageAction } from '../messages/messages-actions'
import { MessageTypes } from '../messages/messages-types'

/* Sage Generator Functions */

// Note: disabling requiring explicit return types for saga generators
// (as the type is pretty complex and produces little value as explicit)
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function * downloadActiveMeters() {
  // note: 'select' function do not work well with TypeScript types
  // (i.e. the return value do not reflect the correct type)
  const idToken: ReturnType<typeof selectIdToken> = yield selectFromState(selectIdToken)
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const response: DownloadFileResponse = yield call(AdminReportsApi.downloadActiveMetersReport, idToken)
  if (!response.succeeded) {
    yield put(AddMessageAction(response.errorKey ?? 'reports.downloadActiveMetersDefaultError', MessageTypes.error))
  } else {
    fileDownload(response.payload.content, 'active_meters_by_company.csv')
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function * reportsSagas() {
  yield takeEvery(DownloadActiveMetersAction, downloadActiveMeters)
}
